/*
	Atualizando os resultados dessa Operação
*/
export default (state, { result } = {}) => 
	state.swagger.instrucoesDePreenchimento.result = result
	

